import React from 'react';
import PropTypes from 'prop-types';

class ModalHeader extends React.PureComponent {
    static propTypes = {
        onClose: PropTypes.func,
        headerText: PropTypes.string.isRequired,
        headerClassName: PropTypes.string,
        hideCloseButton: PropTypes.bool,
    };

    static defaultProps = {
        onClose: null,
        headerClassName: undefined,
        hideCloseButton: false,
    };

    render() {
        let headerClassNames = 'm2g-h2 m2g-modal-title';
        if (this.props.headerClassName) {
            headerClassNames += ` ${this.props.headerClassName}`;
        }
        return (
            <div className="m2g-modal-header">
                {!this.props.hideCloseButton && (
                    <button
                        onClick={() =>
                            this.props.onClose && this.props.onClose()
                        }
                        className="m2g-modal-close-button"
                        data-dismiss="modal"
                    >
                        ×
                    </button>
                )}

                <h2 className={headerClassNames}>{this.props.headerText}</h2>
            </div>
        );
    }
}

export default ModalHeader;
